import { render, staticRenderFns } from "./EventEmailTemplate.vue?vue&type=template&id=24c37dde"
import script from "./EventEmailTemplate.vue?vue&type=script&lang=js"
export * from "./EventEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports